// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"zau-3","companyAvatar":"GTI1f"};